import React from 'react';
import { MAJOR_APPLIANCE } from '../../components/constants';
import { PICKUP_TEMPLATES } from './templatesConstant';

const contactTemplate = (storeName) => {
  return (
    <div className="store__message">
      <div className="store__text-box">
        <div id="check-nearby-store" className="store__second-line">
          <span className="store__warning">Contact {storeName || 'your local store'}</span>
        </div>
      </div>
    </div>
  );
};

const noStoreTemplates = ({ values } = {}) => {
  const message = values?.message?.includes('Not sold in stores') ? values?.message : 'Unavailable';
  const isAppliance = values?.product?.identifiers?.productType === MAJOR_APPLIANCE;
  const isStoreNameAvailable = values?.storeName;
  if (isAppliance || !isStoreNameAvailable) {
    return contactTemplate();
  }
  return (
    <div className="store__message">
      <div className="store__text-box">
        <div id="check-nearby-store" className="store__second-line">
          <span className="store__primary">
            {message}
          </span>
        </div>
      </div>
    </div>
  );
};

const renderInStock = ({ values }) => {
  const isQuantityZero = values?.formattedQty === 0;
  if (isQuantityZero) {
    return noStoreTemplates();
  }

  return (
    <div className="store__message">
      <div className="store__text-box">
        <div id="check-nearby-store" className="store__second-line">
          <span className="store__success">{`${values?.formattedQty} in stock`}</span>
          <span className="store__dark">{` | ${values?.storeName}`}</span>
        </div>
      </div>
    </div>
  );
};

const renderInStockNearBy = ({ values }) => {
  const isQuantityZero = values?.formattedQty === 0;
  if (isQuantityZero) {
    return noStoreTemplates();
  }

  return (
    <div className="store__message">
      <div className="store__text-box">
        <div id="check-nearby-store" className="store__second-line">
          <span className="store__success">{`${values?.formattedQty} nearby`}</span>
          <span className="store__dark">{` | ${values?.storeName}`}</span>
        </div>
      </div>
    </div>
  );
};

const renderBoss = ({ values }) => {
  const isFree = values?.messagingSuccess?.trim() === 'Free';
  return (
    <div className="store__message">
      <div className="store__text-box">
        <div className="store__second-line">
          <span className="store__success">
            {isFree && `${values?.messagingSuccess} ship to store`}
            {
              !isFree
             && (
               <>
                 <span className="store__success">{values?.messagingSuccess}</span>
                 <span className="store__dark"> | </span>
                 <span className="store__success">Free ship to store</span>
               </>
             )
            }
          </span>
        </div>
      </div>
    </div>
  );
};

const limitedAvailabilityTemplate = ({ values }) => {
  return (
    <div className="store__message">
      <div className="store__text-box">
        <div id="check-nearby-store" className="store__second-line">
          <span className="store__warning">Limited stock</span>
          <span className="store__dark">{` | ${values?.storeName}`}</span>
        </div>
      </div>
    </div>
  );
};

const bopisTemplate = ({ values }) => {
  const isQuantityZero = values?.formattedQty === 0;
  if (isQuantityZero) {
    return contactTemplate(values?.storeName || '');
  }
  return (
    <div className="store__message">
      <div className="store__text-box">
        <div id="check-nearby-store" className="store__second-line">
          <span className="store__success">{`${values?.formattedQty} in stock`}</span>
          <span className="store__dark">{` | ${values?.storeName}`}</span>
        </div>
      </div>
    </div>

  );
};

const liveGoodsTemplate = ({ values }) => {
  const className = values?.message?.includes('Out of Season') ? 'store__primary' : 'store__success';

  return (
    <div className="store__message">
      <div className="store__text-box">
        <div className="store__second-line">
          <span className={className}>{values?.message}</span>
          {values?.storeName && (
            <div className="u__inline">
              <span className="store__dark">{` | ${values?.storeName}`}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const renderTemplates = {
  [PICKUP_TEMPLATES.IN_STOCK]: renderInStock,
  [PICKUP_TEMPLATES.IN_STOCK_NEARBY]: renderInStockNearBy,
  [PICKUP_TEMPLATES.BOSS]: renderBoss,
  [PICKUP_TEMPLATES.NO_STORE_OPTION]: noStoreTemplates,
  [PICKUP_TEMPLATES.LIMITED_AVAILABILITY_NEARBY]: limitedAvailabilityTemplate,
  [PICKUP_TEMPLATES.LIMITED_AVAILABILITY]: limitedAvailabilityTemplate,
  [PICKUP_TEMPLATES.BOPIS_OFF_MESSAGE]: bopisTemplate,
  [PICKUP_TEMPLATES.EMPTY_STORE_MESSAGE]: noStoreTemplates,
  [PICKUP_TEMPLATES.LIVE_GOODS_POD]: liveGoodsTemplate
};

export const renderPickupTemplates = ({ pickUpTemplate, icon, values }) => {
  return renderTemplates[pickUpTemplate]
    ? renderTemplates[pickUpTemplate]({ pickUpTemplate, icon, values }) : contactTemplate();
};